module.exports = require('./helpers/bundle-url').getBundleURL('drLhz') + "../assets/images/hu.3df7cf82.png";